import { useEffect, useState } from 'react'
import axios from '../helpers/axios'

export const createNewRole = async (values, callback) => {
    await axios.post(`/role/createrole/`, values).then(res => {
        callback(res.data.response)
    })
}

export const updateRole = async (id, values, callback) => {
    await axios.put(`/role/updaterole/${id}`, values).then(res => {
        callback(res.data.response)
    })
}
export const deleteRole = async (id, callback) => {
    await axios.put(`/role/deleterole/${id}`, null).then(res => {
        callback(res.data.response)
    })
}

export const getAllRoles = async (rowPerPage, pageNumber, search, callback) => {
    await axios.get(`/role/?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}&search=${search}`)
        .then(res => {
            callback(res.data.data);
        })
}

export const getRoleById = async (id, callback) => {
    await axios.get(`/role/${id}`).then(res => {
        callback(res.data.data)
    })
}

export const getRoles = async (callback) => {
    await axios.get(`/role/allrole/`).then(res => {
        callback(res.data.data)
    })
}

export const RoleAPI = () => {
    const [roles, setRoles] = useState([]);
    const [allRoles, setAllRoles] = useState([]);
    const [roleDetail, setRoleDetail] = useState({})

    const [rowPerPage, setRowPerPage] = useState(10);
    const [search, setSearch] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [callback, setCallback] = useState(false);
    const [id, setId] = useState(0)

    const isUser=localStorage.getItem("login");

    useEffect(() => {
        if(!isUser) return ;

        const fetchData=async()=>{
            try {
                const roleData = await new Promise((resolve) =>
                    getAllRoles(rowPerPage, pageNumber, search, resolve)
                );
                setAllRoles(roleData);
                setTotalPages(roleData.totalPage || 1);

                const rolesList = await new Promise((resolve) => getRoles(resolve));
                setRoles(rolesList);

                if (id) {
                    const roleDetails = await new Promise((resolve) => getRoleById(id, resolve));
                    setRoleDetail(roleDetails);
                }
            } catch (err) {
                console.error("Error fetching roles: ",err)
            }
        };

        fetchData();
    }, [callback, rowPerPage, search, pageNumber, id,isUser]);

    return {
        allRoles: [allRoles, setAllRoles],
        roles: [roles, setRoles],
        roleDetail: [roleDetail, setRoleDetail],
        id: [id, setId],
        rowPerPage: [rowPerPage, setRowPerPage],
        search: [setSearch],
        pageNumber: [setPageNumber],
        totalPages: [totalPages, setTotalPages],
        callback: [callback, setCallback],
    }
}